import React from 'react';
import { MailIcon, StarIcon } from 'lucide-react';
type HeroReview = {
  name: string;
  email: string;
  city: string;
  age: number;
  message: string;
};
const REVIEWS: HeroReview[] = [{
  name: 'Tomás G.',
  email: 'tomas.garcia@gmail.com',
  city: 'La Plata',
  age: 21,
  message: 'Antes en los penales me tiraba por intuición. Con el módulo de lectura empecé a mirar el apoyo y ya se nota muchísimo.'
}, {
  name: 'Nicolás R.',
  email: 'nicorivera.98@gmail.com',
  city: 'Córdoba',
  age: 26,
  message: 'Lo terminé de leer en dos días. El posicionamiento desde los extremos me ordenó la cabeza y ahora llego mucho más preparado.'
}, {
  name: 'Franco M.',
  email: 'fran.martinez.arquero@gmail.com',
  city: 'Rosario',
  age: 19,
  message: 'El bonus de reflejos lo estoy haciendo en casa. Me sirve perfecto para sumar sin depender de tener cancha todos los días.'
}, {
  name: 'Agustín V.',
  email: 'agus.villalba@gmail.com',
  city: 'Mendoza',
  age: 29,
  message: 'Lo mejor es la parte mental: después de un gol malo pude volver a enfocarme en la siguiente pelota, no en el error.'
}];
function ReviewCard({
  review
}: {
  review: HeroReview;
}) {
  return <article className="min-w-[268px] snap-center overflow-hidden rounded-2xl border border-zinc-300 bg-white text-left text-zinc-900 shadow-xl sm:min-w-[300px]" aria-label={`Reseña por correo de ${review.name}`} data-id="element-208" data-mp="2nrrq9d956ibh">
      <div className="flex items-center justify-between border-b border-zinc-200 px-4 py-3" data-id="element-209" data-mp="1zzuchgm4tg7q">
        <div className="flex min-w-0 items-center gap-2.5" data-id="element-210" data-mp="24z738cg4j7fl">
          <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-red-500 text-white" data-id="element-211" data-mp="24xvvy2ngzhjq">
            <MailIcon className="h-4 w-4" data-id="element-212" data-mp="29w76ygpi3y3j" />
          </div>
          <div className="min-w-0" data-id="element-213" data-mp="3gdauhavbuhgy">
            <p className="truncate text-xs font-bold leading-none" data-id="element-214" data-mp="3gggggh8nt38g">{review.name}</p>
            <p className="mt-1 truncate text-[10px] text-zinc-500" data-id="element-215" data-mp="3lbvw9eq8997i">{review.email}</p>
          </div>
        </div>
        <span className="ml-2 shrink-0 text-[10px] font-medium text-zinc-400" data-id="element-216" data-mp="2vre9he5pmb7e">hace poco</span>
      </div>

      <div className="px-4 pb-4 pt-3" data-id="element-217" data-mp="2qsku1g6v4a4l">
        <div className="mb-3 flex items-center gap-1" data-id="element-218" data-mp="35nr1m7llwh01">
          {Array.from({
          length: 5
        }).map((_, index) => <StarIcon key={index} className="h-3.5 w-3.5 fill-[#c6ff2e] text-[#c6ff2e]" aria-hidden="true" data-id="element-219" data-mp="30pfsjz34yaiv" data-mpi={index} />)}
        </div>
        <p className="text-sm font-medium leading-relaxed text-zinc-700" data-id="element-220" data-mp="280ibfzanujrp">“{review.message}”</p>
        <p className="mt-4 text-[11px] font-semibold text-zinc-500" data-id="element-221" data-mp="2mov70v5u60lo">
          {review.name} · {review.age} años · {review.city}
        </p>
      </div>
    </article>;
}
export function HeroReviewCarousel() {
  return <section className="mx-auto mt-7 max-w-md text-left" aria-labelledby="hero-reviews-title" data-id="element-222" data-mp="1u710v3zychdt">
      <div className="mb-5 rounded-2xl border border-zinc-800 bg-zinc-900/70 px-4 py-3.5 text-center shadow-lg" data-id="element-223" data-mp="1p8fzv2cvltob">
        <p id="hero-reviews-title" className="text-xs font-semibold uppercase tracking-[0.16em] text-zinc-400" data-id="element-224" data-mp="4pm1w1x11vct">
          Elegido por más de
        </p>
        <p className="mt-0.5 font-display text-2xl font-black uppercase tracking-wide text-white" data-id="element-225" data-mp="3qywzzw0hi9h9">
          300 arqueros de handball
        </p>
        <div className="mx-auto mt-2.5 flex w-fit items-center gap-2 rounded-full bg-black/30 px-3 py-1.5" aria-label="Calificación de 4.8 sobre 5" data-id="element-226" data-mp="3vy1aqr324f9p">
          <div className="flex gap-0.5" data-id="element-227" data-mp="sgj42mz0teav">
            {Array.from({
            length: 5
          }).map((_, index) => <StarIcon key={index} className="h-3.5 w-3.5 fill-[#c6ff2e] text-[#c6ff2e]" aria-hidden="true" data-id="element-228" data-mp="ehjbj48e0f9f" data-mpi={index} />)}
          </div>
          <span className="text-sm font-extrabold text-white" data-id="element-229" data-mp="2z6pi6s98sr1a">4.8</span>
          <span className="text-xs font-medium text-zinc-400" data-id="element-230" data-mp="2z9lds9xmb3mk">de 5 · opiniones reales</span>
        </div>
      </div>

      <div className="-mx-4 flex snap-x snap-mandatory gap-3 overflow-x-auto px-4 pb-3 pt-1 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden" aria-label="Reseñas de arqueros; deslizá para ver más" data-id="element-231" data-mp="3jfp3n6dm6st1">
        {REVIEWS.map(review => <ReviewCard key={review.email} review={review} data-id="element-232" data-mp="39o2t7c93oxrc" />)}
        <div className="w-1 shrink-0" aria-hidden="true" data-id="element-233" data-mp="34sdq4yxvgyqa" />
      </div>
      <p className="mt-1 text-center text-[11px] font-medium text-zinc-500" data-id="element-234" data-mp="69yqulxagg2l">
        Deslizá para ver más reseñas
      </p>
    </section>;
}